import React from 'react'
import StudentList from "../_components/UI/StudentList";
import Header from '../_components/common/Header';

const Students = () => {
  return (
    <div className='page-main'>
        <Header name={ ["Upload Answer Sheets","Student list"] }/>
      <StudentList />
        
    </div>
  )
}

export default Students